import useSWR from 'swr'
import { API_BASE_URL } from 'config/api'
import { fetcher, IError } from 'utils/fetchers'

const apiUrl = `${API_BASE_URL}/categories/with-product-count`

interface Category {
  id: string
  name: string
  product_count: number
}

type Categories = Category[]

export function useFetchCategories() {
  const { data, error } = useSWR<Categories, IError | null>(
    `${apiUrl}`,
    fetcher,
  )
  return {
    categories: data,
    isLoading: !error && !data,
    isError: !!error,
    error: error,
  }
}
